import React, { useContext, ReactNode } from "react";
import { DialogContext } from "./dialog.context";
import * as S from "./Trigger.styles";

export interface DialogTriggerProps {
  children: ReactNode;
  onHoverChange?: (isHovered: boolean) => void;
}

export const DialogTrigger = ({
  children,
  onHoverChange
}: DialogTriggerProps) => {
  const dialogContext = useContext(DialogContext);

  const handleMouseEnter = () => {
    dialogContext.setIsOpen(true);
    onHoverChange?.(true);
  };

  const handleMouseLeave = () => {
    dialogContext.setIsOpen(false);
    onHoverChange?.(false);
  };

  return (
    <S.Trigger
      asChild
      $hoverState={dialogContext.isOpen}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </S.Trigger>
  );
};

export default DialogTrigger;
